import { render, staticRenderFns } from "./traindal.vue?vue&type=template&id=93a0cfd4&"
import script from "./traindal.vue?vue&type=script&lang=js&"
export * from "./traindal.vue?vue&type=script&lang=js&"
import style0 from "./traindal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports